import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { EmployeeService } from 'src/app/services/employee/employee.service'
import {
  fetch_employee_with_reference_details,
  fetch_employee_with_reference_details_success,
  load_employee_summary_action,
  load_employee_summary_success_action
} from '../action/employee.action'
import { catchError, map, mergeMap, of } from 'rxjs'
import { show_error_action } from '../action/common/common.action'

@Injectable()
export class EmployeeEffects {
  constructor(private actions$: Actions, private employeeService: EmployeeService) {}
  load_employee_summary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(load_employee_summary_action),
      mergeMap(data =>
        this.employeeService.invokeEmployeeSummaryAPI(data.queryParams, data.searchRequestBody).pipe(
          map(empResponce => load_employee_summary_success_action({ employee: empResponce })),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  fetch_employee_with_reference_details$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetch_employee_with_reference_details),
      mergeMap(action =>
        this.employeeService.getEmployeeWithReferenceDetails(action.employeeId).pipe(
          mergeMap(response => [fetch_employee_with_reference_details_success(response)]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
